// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"418":"36cb6c0cab38ecc2","609":"ade206e6b4f5fe96"}[chunkId] + ".js";
};